import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-housing-report',
  templateUrl: './housing-report.component.html',
  styleUrls: ['./housing-report.component.css']
})
export class HousingReportComponent implements OnInit {

  model = { 'table_name': 'trip', 'trip_id': '', 'trip_name': '', 'trip_number': '' };
  displayedColumns = ['sr', 'hotel_name', 'arrival_date', 'depart_date', 'room_type', 'room_count', 'available_room'];

  private dp = [];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  Residence_Report; Program;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private dialogRef: MatDialogRef<HousingReportComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
      this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Residence_Report').subscribe((res: string) => {
      this.Residence_Report = res;
    }); 

    translate.get('Program').subscribe((res: string) => {
      this.Program = res;
    });
  }

  ngOnInit() {
    if (this.dialog_data != null) {
      this.model = this.dialog_data[0];
      
      let obj = { cmd: 'getHotelRoomRep', 'trip_id': this.model['trip_id'] };
      this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'error') 
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        else if (data.status['type'] == 'success') {
          let result = data.status['msg'][0];

          // get trip detail
          let trip_info = result['trip_info'];
          this.model['trip_name'] = trip_info['trip_name'];
          this.model['trip_number'] = trip_info['trip_number'];

          this.dp = result['hotel_room_list'];;
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        }
      });
    }
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="99%"> ' + this.Program + ': ' + this.model['trip_name'] + '(' + this.model['trip_number'] + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('hotel_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.Residence_Report);
  }

  close() {
    this.dialogRef.close(this.dialog_data);
  }

}
